//#region imports
import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { GuaranteeComponentModel } from '../../model/tarif.model';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-guarantee',
  templateUrl: './guarantee.component.html',
  styleUrls: ['./guarantee.component.css']
})
export class GuaranteeComponent implements OnInit, AfterContentChecked {
  //#region  variables
  showNormalTitle = true;
  showNormalTitleMobile = true;
  premiumTotalAmount: string;
  guaranteeComponent: GuaranteeComponentModel;
  abexValue: string;
  showPremiumtag: boolean = false;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private globals: Globals, private sectionService: SectionService,
    private changeDetectorRef: ChangeDetectorRef, private notificationService: NotificationService) { }

  ngOnInit() {
    const isRetrieveSimulation = this.sectionService.getIsRetrieveSimulation();
    if (isRetrieveSimulation) {
      this.guaranteeService.setGuaranteeProgressBarDetails();
      if(this.globals.isMobile)
      this.guaranteeService.setmobileGuaranteeProgressBarDetails();
      this.sectionService.setIsRetrieveSimulation(false);
    }
    const guaranteeFromRecapitulatory = this.guaranteeService.getGuaranteeFromRecapitulatory();
    this.guaranteeService.getGuaranteeComponent().subscribe((value) => {
      this.guaranteeComponent = value;
    });
    if (!this.guaranteeComponent) {
      if (!guaranteeFromRecapitulatory) {
        this.guaranteeComponent = {
          GuaranteeQuestion1: true, GuaranteeQuestion2: false, GuaranteeQuestion3: false,
          GuaranteeQuestion4: false, GuaranteeQuestion5: false
        };
      } else {
        this.guaranteeComponent = {
          GuaranteeQuestion1: false, GuaranteeQuestion2: false, GuaranteeQuestion3: false,
          GuaranteeQuestion4: false, GuaranteeQuestion5: true
        };
        this.premiumTotalAmount = this.guaranteeService.getInitialPricingData().Tarification.Premium_Total_Amount;
      }
      this.guaranteeService.setGuaranteeComponent(this.guaranteeComponent);
    }
    this.globals.guaranteeHeader1 = false;
    this.globals.guaranteeHeader2 = false;
    this.guaranteeService.getPremiumTotalAmount().subscribe((value) => {
      this.premiumTotalAmount = value;
    });
    this.abexValue = this.globals.abexValueGlobal;
    this.guaranteeService.getPremiumTotalShow().subscribe((value) => {
      this.showPremiumtag = value;
    });
    this.showPremiumtag = this.globals.isTheftZero;
  }

  ngAfterContentChecked() {
    this.guaranteeService.getshowNormalTitle().subscribe((value) => {
      this.showNormalTitle = value;
      this.showNormalTitleMobile = value;
    });
    this.changeDetectorRef.detectChanges();
  }

  saveDialog() {
    this.notificationService.saveDialog();
  }
  //#endregion
}
